/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { AddPublicPrivateNotesProps, ECollapsedNotes } from '../../types';
import { containerCss } from '../../styles';
import { CollapsedNotesLine } from '../collapsed-notes-line';

export const AddPublicPrivateNotes: FC<AddPublicPrivateNotesProps> = ({
	initialPublicNote,
	initialPrivateNote,
	onChange,
}) => {
	const [isPrivateShowing, setIsPrivateShowing] = useState<Dayjs | null>(initialPrivateNote ? dayjs() : null);
	const noteType = isPrivateShowing ? ECollapsedNotes.BOTH : ECollapsedNotes.PUBLIC;

	const handleOnChange = (publicText?: string, privateText?: string) => {
		onChange(publicText, privateText);
	};

	const handleOpenPrivateNote = () => {
		setIsPrivateShowing(dayjs());
	};

	return (
		<div css={containerCss} data-aid="index-add-note">
			<CollapsedNotesLine
				type={noteType}
				onOpen={handleOpenPrivateNote}
				onChange={handleOnChange}
				initialPublicNote={initialPublicNote}
				initialPrivateNote={initialPrivateNote}
			/>
		</div>
	);
};
